import { Routes } from '../../../app/AppRouter';
import React from 'react';
import { LoginEmailInput } from './LoginEmailInput';
import { NotificationBanner } from '../../shared/NotificationBanner/NotificationBanner';
import { useDispatch, useSelector } from 'react-redux';
import { LoginState, selectLoginState, setLoginState } from '../../../features/login/loginSlice';
import { LoginUsernameInput } from './LoginUsernameInput';
import './Login.scss';
import { LoginNextActions } from './LoginNextActions';
import { Link } from 'react-router-dom';

const ERROR_MESSAGES: { [key: string]: string } = {
  emailNotRecognised: 'Sorry, this email is not recognised.',
  emailNotValid: 'Email is not valid.',
  usernameNotRecognised: 'Sorry, this Url is not recognised',
  usernameNotValid: 'Url is not valid',
};

export const Login: React.FC = () => {
  const state = useSelector(selectLoginState);
  const dispatch = useDispatch();

  return (
    <div className="hatters-flex-column-container">
      {state.error.displayError && (
        <NotificationBanner type={'error'} message={ERROR_MESSAGES[state.error.errorType]} />
      )}

      <span className={'flex-spacer-small'} />

      <div className="login-wrapper">
        <div className="login-title-container">
          <div className="hatters-title">
            Log in with {state.loginState === LoginState.username ? 'HAT URL' : 'email'}
          </div>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          {state.loginState === LoginState.username && <LoginUsernameInput />}

          {state.loginState === LoginState.email && <LoginEmailInput />}
        </form>

        <div className="login-user-actions">
          <LoginNextActions />
        </div>

        <div className="hatters-description-small login-small-text">
          After pressing ‘Next’ you will be re-directed to your HAT to enter your password
        </div>

        <div className="hatters-description-normal">OR</div>

        <button
          className="hatters-btn hatters-btn-transparent-border"
          onClick={() =>
            dispatch(setLoginState(state.loginState === LoginState.username ? LoginState.email : LoginState.username))
          }
        >
          Log in with {state.loginState === LoginState.username ? 'email' : 'HAT URL'}
        </button>

        <div className="hatters-description-normal">
          Don't have an account? <Link to={Routes.hatSignup + window.location.search}>Create one</Link>{' '}
        </div>
      </div>
      <span className={'flex-spacer-large'} />
    </div>
  );
};
